// extracted by mini-css-extract-plugin
module.exports = {"footer":"LARCard_footer__2FyJj"};